import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { fetchUnassignedLeadsData } from "../../../redux/reducers/apiSlice";
import {
  convertStraight,
  convertThenFormat,
  formatDateTime,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import AssignForm from "./AssignForm";
import BackAddBtns from "../../Open-pages/target-matrics/common/BackAddBtns";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { leadCountDetails } from "../../../data/ApiEndpoints";
import DashboardCard from "../../../pages/home/common/DashboardCard";
import UTMParams from "./UTMParams";
import ImportRawLeads from "./ImportRawLeads";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const RawLeadListings = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  filters,
  tableRef,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { unassignedLeadsLoading, unassignedLeads } = useSelector(
    (state) => state.api
  );
  const { data, loading } = useSelector((state) => state.common);

  const isMarketing = userInfoData?.account_type === "marketing";

  const iniDatas = {
    pagination: [],
    allLeads: [],
    statCards: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const iniModValues = {
    isModalOpen: false,
    modName: "",
    rawLeadId: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [isPageLC, setIsPageLC] = useState(0);
  const iniLcFilters = {
    limit: 10,
    page: isPageLC + 1,
    lead_id: modValues.rawLeadId || "",
  };
  const [lcFilters, setLcFilters] = useState(iniLcFilters);
  const iniLeadCounts = {
    leadCountDetails: [],
    leadCountPagination: [],
  };
  const [leadCounts, setLeadCounts] = useState(iniLeadCounts);

  function closeModal() {
    setModValues(iniModValues);
  }

  function getAllLeads(filters) {
    dispatch(
      fetchUnassignedLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleCheckboxChange = (event, row) => {
    const isChecked = event.target.checked;

    const updatedRows = allDatas.allLeads.map((r) =>
      r.uid === row.uid ? { ...r, checked: isChecked } : r
    );

    setSelectedRows(
      isChecked
        ? [...selectedRows, { ...row, checked: isChecked }]
        : selectedRows.filter((selectedRow) => selectedRow.uid !== row.uid)
    );

    allDatas.allLeads = updatedRows;
  };

  const handleToggleAllClick = (event) => {
    const isChecked = event.target.checked;

    const updatedRows = allDatas.allLeads.map((row) => {
      if (row.is_assigned && row?.added_to_lead) {
        return row;
      }

      return {
        ...row,
        checked: isChecked,
      };
    });

    const selectedRows = isChecked
      ? updatedRows.filter((row) => !row.lead_id)
      : [];

    setSelectedRows(selectedRows);
    setIsAllSelected(isChecked);

    allDatas.allLeads = updatedRows;
  };

  function getLeadCountDetails(lcFilters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: leadCountDetails,
        payload: {
          filters: lcFilters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllLeads(filters);
  }, [filters]);

  useEffect(() => {
    if (unassignedLeads?.status && unassignedLeads?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: unassignedLeads.data,
        pagination:
          unassignedLeads?.pagination?.length > 0
            ? unassignedLeads.pagination
            : [],
        statCards: unassignedLeads?.stats,
      }));
    } else {
      setAllDatas({
        pagination: [],
        allLeads: [],
        statCards: {},
      });
    }
  }, [unassignedLeads]);

  useEffect(() => {
    setLcFilters((prevs) => ({
      ...prevs,
      page: isPageLC + 1,
      lead_id: modValues.rawLeadId || "",
    }));
  }, [modValues.rawLeadId, isPageLC]);

  useEffect(() => {
    if (modValues.modName === "lead-count" && lcFilters.lead_id) {
      getLeadCountDetails(lcFilters);
    }
  }, [modValues.modName, lcFilters]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0) {
      setLeadCounts((prevs) => ({
        ...prevs,
        leadCountDetails: data.data,
        leadCountPagination: data.pagination,
      }));
    } else {
      setLeadCounts(iniLeadCounts);
    }
  }, [data]);

  const tbColumns = [
    !isMarketing && {
      dataField: "select",
      text: (
        <div
          className="input-with-label"
          style={{ justifyContent: "flex-start" }}
        >
          <input
            type="checkbox"
            onChange={(event) => handleToggleAllClick(event)}
            checked={isAllSelected}
          />
          <label htmlFor="select">
            {isAllSelected ? "Unselect All" : "Select All"}
          </label>
        </div>
      ),
      formatter: (_, row) => {
        // const isDisbaled = row?.lead_id;
        // const isDisbaled = false;
        const isDisbaled = row?.is_assigned && row?.added_to_lead;

        return (
          <div className="tbDataFlexCenter checkbox-container">
            <input
              type="checkbox"
              onChange={(event) => handleCheckboxChange(event, row)}
              checked={row.checked}
              disabled={isDisbaled}
            />
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "is_assigned",
      text: "assigned",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_assigned ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "added_to_lead",
      text: "Added To Lead",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.added_to_lead ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "keyword_name",
      text: "keyword name",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() =>
              setModValues({
                isModalOpen: true,
                modName: "lead-count",
                rawLeadId: row?.uid,
                rowData: row,
              })
            }
          >
            {row?.keyword_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "source_name",
      text: "source name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.source_name?.toLowerCase() === "wtf_one_day_plan"
              ? "WTF One Day Plan"
              : row?.source_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "utm_source",
      text: "UTM source",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.utm_source ? "link" : ""}`}
            onClick={() =>
              row?.utm_source &&
              setModValues({
                isModalOpen: true,
                modName: "utm_parameters",
                rawLeadId: row?.uid,
                rowData: row,
              })
            }
          >
            {row?.utm_source || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "date",
      text: "Trial Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "preferred_slot",
      text: "preferred slot",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.preferred_slot || "-"}
          </span>
        );
      },
    },
    {
      dataField: "lead_added_count",
      text: "lead count",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() =>
              setModValues({
                isModalOpen: true,
                modName: "lead-count",
                rawLeadId: row?.uid,
                rowData: row,
              })
            }
          >
            {row?.lead_added_count || 0}
          </span>
        );
      },
    },
    {
      dataField: "assigned_by_id",
      text: "Assigned By",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.assigned_by_name || "NA"}</span>;
      },
    },
    {
      dataField: "assigned_to_id",
      text: "Assign To",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.assigned_to_name || "NA"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "assigned_date",
      text: "Assign Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.assigned_date ? formatDateTime(row.assigned_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "rawlead_to_assign_day",
      text: "Raw Lead To Assign",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.rawlead_to_assign || 0}
          </span>
        );
      },
    },
    {
      dataField: "assign_to_followup",
      text: "Assigned To First Followup",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.assign_to_followup || 0}
          </span>
        );
      },
    },
    {
      dataField: "first_followup",
      text: "first followup date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.first_followup ? formatDateTime(row.first_followup) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "conversion_date",
      text: "Conversion Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.conversion_date ? formatDateTime(row.conversion_date) : "-"}
            <br />
            {row?.conversion_days ? (
              <small className="underline">({row.conversion_days || ""})</small>
            ) : null}
          </span>
        );
      },
    },
    {
      dataField: "city",
      text: "city",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.city || "NA"}</span>;
      },
    },
  ];

  const leadCountsTbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "keyword",
      text: "keyword",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.keyword || "NA"}</span>;
      },
    },
    {
      dataField: "source_name",
      text: "source name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.source_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Trial Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date ? convertStraight(row.date) : ""}
          </span>
        );
      },
    },
    {
      dataField: "preferred_slot",
      text: "preferred slot",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.preferred_slot || "-"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : ""}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Assign Leads Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "assign" ? "adjustable-modal" : ""
          } ${modValues.modName === "utm_parameters" || modValues.modName === "import_csv" ? "mod-width-50p" : ""}`}
        >
          <ModalHeadAndClose
            title={`${
              modValues.modName === "assign"
                ? "Assign Leads"
                : modValues.modName === "lead-count"
                ? "Lead Count Details: " +
                  modValues.rowData?.name +
                  "/" +
                  modValues.rowData?.mobile
                : modValues.modName === "utm_parameters"
                ? "UTM Parameters"
                : modValues.modName === "import_csv"
                ? "Import Raw Leads"
                : modValues.modName?.replace(/_/g, " ")
            }`}
            onClose={closeModal}
          />

          {modValues.modName === "assign" ? (
            <AssignForm
              userInfoData={userInfoData}
              selectedRows={selectedRows}
              closeModal={() => {
                callFunction();
                getAllLeads(filters);
                setSelectedRows([]);
                setIsAllSelected(false);
                closeModal();
                setAllDatas((prevState) => ({
                  ...prevState,
                  allLeads: prevState.allLeads.map((lead) => ({
                    ...lead,
                    checked: false,
                  })),
                }));
              }}
            />
          ) : modValues.modName === "lead-count" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={leadCounts.leadCountDetails}
                  tableColumns={leadCountsTbColumns}
                  tablePagination={leadCounts.leadCountPagination}
                  isPage={isPageLC}
                  setIsPage={(value) => setIsPageLC(value)}
                />
              )}
            </div>
          ) : modValues.modName === "utm_parameters" ? (
            <UTMParams rowData={modValues.rowData} />
          ) : modValues.modName === "import_csv" ? (
            <ImportRawLeads
              userInfoData={userInfoData}
              closeModal={() => {
                callFunction();
                getAllLeads(filters);
                closeModal();
              }}
            />
          ) : null}
        </div>
      </Modal>

      <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
        {allDatas.statCards &&
          Object?.entries(allDatas.statCards)?.map(([key, value], index) => (
            <React.Fragment key={index}>
              {(key === "total_leads" ||
                key === "google_lead" ||
                key === "facebook_lead") && (
                <DashboardCard
                  tagName={`leads_tb_cards`}
                  cardLabel={
                    key === "total_leads"
                      ? "Total Raw Leads"
                      : key?.replace(/_/g, " ")
                  }
                  value={convertThenFormat(value || 0)}
                />
              )}
            </React.Fragment>
          ))}

        <DashboardCard
          tagName={`leads_tb_cards`}
          cardLabel={"Assigned Leads Converted"}
          subLabel={`Lead Value: ₹${convertThenFormat(
            allDatas.statCards?.assigned_converted?.lead_value || 0
          )}`}
          value={`₹${convertThenFormat(
            allDatas.statCards?.assigned_converted?.converted_value || 0
          )}(${convertThenFormat(
            allDatas.statCards?.assigned_converted?.count || 0
          )})`}
        />

        <DashboardCard
          tagName={`leads_tb_cards`}
          cardLabel={"Assigned Leads Pending Follow-up"}
          subLabel={`Lead Value: ₹${convertThenFormat(
            allDatas.statCards?.assigned_pending?.lead_value || 0
          )}`}
          value={`${convertThenFormat(
            allDatas.statCards?.assigned_pending?.count || 0
          )}`}
        />

        <DashboardCard
          tagName={`leads_tb_cards`}
          cardLabel={"Assigned Leads Closed"}
          subLabel={`Lead Value: ₹${convertThenFormat(
            allDatas.statCards?.assigned_closed?.lead_value || 0
          )}`}
          value={`${convertThenFormat(
            allDatas.statCards?.assigned_closed?.count || 0
          )}`}
        />

        <DashboardCard
          tagName={`leads_tb_cards`}
          cardLabel={"Facebook Leads Converted"}
          value={`₹${convertThenFormat(
            allDatas.statCards?.facebook_converted?.converted_value || 0
          )}(${convertThenFormat(
            allDatas.statCards?.facebook_converted?.count || 0
          )})`}
        />

        <DashboardCard
          tagName={`leads_tb_cards`}
          cardLabel={"Google Leads Converted"}
          value={`₹${convertThenFormat(
            allDatas.statCards?.google_converted?.converted_value || 0
          )}(${convertThenFormat(
            allDatas.statCards?.google_converted?.count || 0
          )})`}
        />

        <DashboardCard
          tagName={`un_asigned_leads`}
          cardLabel={"Un Assigned Raw Lead"}
          value={`${convertThenFormat(
            allDatas.statCards?.un_asigned_leads || 0
          )}`}
        />
      </div>

      <BackAddBtns
        isRawLead={true}
        addBtnTxt={`${
          selectedRows?.length === 0
            ? "Select Leads From The Table"
            : "Assign Leads"
        }`}
        onClickAdd={() =>
          setModValues({ isModalOpen: true, modName: "assign" })
        }
        addBtnTxt1={"Import CSV"}
        onClickAdd1={() =>
          setModValues({ isModalOpen: true, modName: "import_csv" })
        }
        onClickReload={() => {
          getAllLeads(filters);
          setSelectedRows([]);
          setIsAllSelected(false);
          closeModal();
          setAllDatas((prevState) => ({
            ...prevState,
            allLeads: prevState.allLeads.map((lead) => ({
              ...lead,
              checked: false,
            })),
          }));
        }}
        isAddBtn={!isMarketing ? true : false}
        isDiabled={selectedRows?.length === 0}
      />

      <div
        className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30"
        ref={tableRef}
      >
        {unassignedLeadsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allLeads}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isFirstColSticky={true}
          />
        )}
      </div>
    </>
  );
};

export default RawLeadListings;
